import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import consultants from '../../.sourceflow/consultants.json'
import jobs from '../../.sourceflow/jobs.json'
import {
    CardBody,
    List,
    Card
} from "reactstrap";
import Link from 'next/link';
import styles from './styles.module.scss';
import Telephone from '/public/site-assets/svg/phone.svg';
import Mail from '/public/site-assets/svg/mail.svg';

export default function JobConsultant({
    global,
    pathPrefix,
    jobId,
    customClass = "",
    emailText,
    heading
}) {
    const job = jobs.jobs.find((job) => job.id == jobId)
    const consultant = getConsultant(job)
    return (
        consultant?.name ?
            <section className={`${styles.root} ${customClass}`}>
                {consultant?.name ?
                    <Card className="bg-transparent consultant position-relative">
                        <h5 className="heading mb-4">
                            <strong>
                                <SourceFlowText global={global} path={`${pathPrefix}.heading`}>{heading} </SourceFlowText>
                            </strong>
                        </h5>
                        <div className="card-img-wrapper position-relative">
                            <Link href={`/meet-the-team/${consultant?.url_slug}/`}>
                                <a className="text-decoration-none">
                                    <SourceFlowImage
                                        src={consultant?.image?.en ? consultant?.image?.en : "/site-assets/images/image-placeholder.webp"}
                                        size="1000x1500"
                                        alt={consultant?.name?.en}
                                        className="card-img"
                                        width="100%"
                                    />
                                </a>
                            </Link>
                        </div>
                        <CardBody className="ps-0 pe-0 pb-0 pt-3">
                            <Link href={`/meet-the-team/${consultant?.url_slug}/`}>
                                <a className="text-decoration-none">
                                    <h6 className="mb-3 heading"><strong>{consultant?.name?.en}</strong></h6>
                                </a>
                            </Link>
                            {/* <p className="fs-6"><small>{consultant?.position?.en}</small></p> */}
                            <List className="consultant-contact m-0" type="unstyled">
                                {consultant.email?.en ?
                                    <li className="mb-2">
                                        <Link href={`mailto:${consultant.email?.en}`}>
                                            <a className="text-decoration-none">
                                                <Mail />
                                                <strong><small><SourceFlowText global={global} path={`${pathPrefix}.emailText`}>{emailText} </SourceFlowText>
                                                    {consultant?.name?.en}</small></strong>
                                            </a>
                                        </Link>
                                    </li> : null}
                                {consultant.telephone?.en ?
                                    <li className="mb-2">
                                        <Link href={`tel:${consultant.telephone?.en}`}>
                                            <a className="text-decoration-none">
                                                <Telephone />
                                                <strong><small>{consultant?.telephone?.en}</small></strong>
                                            </a>
                                        </Link>
                                    </li> : null}
                            </List>
                        </CardBody>
                    </Card>
                    : null
                }
            </section>
            : ""
    )
}

function getConsultant(job) {
    const all = consultants.category_values ?? []

    // 1. Consultant tagged through the Consultants category (only set on a handful of jobs)
    const consultantId = job.categories?.find(cat => (cat.id === consultants.id))?.values?.[0]?.id
    const tagged = all.find((consultant) => consultant.id == consultantId)
    if (tagged) return tagged

    // 2. Otherwise fall back to the consultant the ATS puts on the job itself. This is how most
    //    jobs are populated, and it matches regardless of whether that consultant is featured
    //    on the Meet the Team page.
    const email = job.consultant_email?.trim().toLowerCase()
    const name = job.consultant_name?.trim().toLowerCase()

    return (email && all.find((consultant) => consultant.email?.en?.trim().toLowerCase() === email))
        || (name && all.find((consultant) => consultant.name?.en?.trim().toLowerCase() === name))
        || undefined
}